module.exports = __webpack_public_path__ + "static/map-alt-daf0157a7f778aae8165defa654f2fd2.png";